import { ScrollTrigger } from '../animations';

/**
 * Block "Intro animata":
 * - word-reveal scroll-scrubbed (le parole si accendono mano a mano, one-way);
 * - hover/focus su una parola-link → fade-in dell'immagine fluttuante associata.
 */
export function initIntroAnimata() {
	document.querySelectorAll( '.tm-anima' ).forEach( ( section ) => {
		initVisualHover( section );
		initWordReveal( section );
	} );
}

/**
 * Lega ogni parola-link alla sua immagine: l'associazione è per indice
 * (data-anima-key ↔ data-anima-img), assegnato lato render.
 */
function initVisualHover( section ) {
	const links   = section.querySelectorAll( '[data-anima-key]' );
	const visuals = section.querySelectorAll( '[data-anima-img]' );
	if ( ! links.length || ! visuals.length ) {
		return;
	}

	const activate = ( key ) =>
		visuals.forEach( ( v ) => v.classList.toggle( 'is-active', v.dataset.animaImg === key ) );
	const clear = () => visuals.forEach( ( v ) => v.classList.remove( 'is-active' ) );

	links.forEach( ( el ) => {
		el.addEventListener( 'mouseenter', () => activate( el.dataset.animaKey ) );
		el.addEventListener( 'mouseleave', clear );
		el.addEventListener( 'focus', () => activate( el.dataset.animaKey ) );
		el.addEventListener( 'blur', clear );
	} );
}

/**
 * Avvolge ogni parola in uno span e la rivela durante lo scroll della sezione.
 * I link restano una singola unità di reveal.
 */
function initWordReveal( section ) {
	if ( window.matchMedia( '(prefers-reduced-motion: reduce)' ).matches ) {
		return;
	}

	const text = section.querySelector( '[data-anima-text]' );
	if ( ! text ) {
		return;
	}
	// Idempotente: se le parole sono già state avvolte non rifare lo split.
	if ( text.querySelector( '.tm-anima__word' ) ) {
		return;
	}

	const nodes = [ ...text.childNodes ];
	text.innerHTML = '';
	nodes.forEach( ( node ) => {
		// Nodo testo: separa in parole, preservando gli spazi.
		if ( node.nodeType === Node.TEXT_NODE ) {
			node.textContent.split( /(\s+)/ ).forEach( ( part ) => {
				if ( ! part ) {
					return;
				}
				if ( /^\s+$/.test( part ) ) {
					text.appendChild( document.createTextNode( part ) );
				} else {
					const span = document.createElement( 'span' );
					span.className = 'tm-anima__word';
					span.textContent = part;
					text.appendChild( span );
				}
			} );
			return;
		}
		// Link/elemento: intera unità di reveal.
		if ( node.classList ) {
			node.classList.add( 'tm-anima__word' );
		}
		text.appendChild( node );
	} );

	const words = [ ...section.querySelectorAll( '.tm-anima__word' ) ];
	if ( ! words.length ) {
		return;
	}

	const lit        = new Array( words.length ).fill( false );
	const fadeWindow = 0.7 / words.length;

	ScrollTrigger.create( {
		trigger: section,
		start: 'top 75%',
		end: 'bottom 70%',
		onUpdate: ( self ) => {
			const p = self.progress;
			words.forEach( ( word, i ) => {
				if ( lit[ i ] ) {
					return;
				}
				const tStart = i / words.length;
				const tEnd   = tStart + fadeWindow;
				if ( p < tStart ) {
					word.style.opacity = 0.18;
				} else if ( p >= tEnd ) {
					word.style.opacity = 1;
					lit[ i ] = true;
				} else {
					word.style.opacity = 0.18 + 0.82 * ( p - tStart ) / fadeWindow;
				}
			} );
		},
	} );
}
